import { computed } from 'vue';
import { useAvailabilityStore } from '../stores/availability.store';
export function useAvailability(options = {}) {
    const store = useAvailabilityStore();
    const items = computed(() => store.items);
    const calendarId = computed(() => store.calendarId);
    const hasChanges = computed(() => store.hasChanges);
    const isLoading = computed(() => store.isLoading);
    const error = computed(() => store.error);
    const lastBookingImpact = computed(() => store.lastBookingImpact);
    const availabilities = computed(() => store.availabilities);
    const overrides = computed(() => store.overrides);
    const newItems = computed(() => store.newItems);
    const modifiedItems = computed(() => store.modifiedItems);
    async function load(serviceId) {
        await store.loadForService(serviceId);
    }
    if (options.serviceId) {
        load(options.serviceId);
    }
    function addAvailability(data) {
        store.addAvailability(data);
    }
    function addOverride(data) {
        store.addOverride(data);
    }
    function updateItem(index, data) {
        store.updateItem(index, data);
    }
    function removeItem(index) {
        return store.removeItem(index);
    }
    async function saveAll() {
        try {
            await store.saveAll();
            options.onSaveSuccess?.();
        }
        catch (err) {
            const error = err instanceof Error ? err : new Error('Error saving availability');
            options.onSaveError?.(error);
            throw error;
        }
    }
    function reset() {
        store.reset();
    }
    function setServiceId(id) {
        store.serviceId = id;
    }
    return {
        items,
        calendarId,
        hasChanges,
        isLoading,
        error,
        lastBookingImpact,
        availabilities,
        overrides,
        newItems,
        modifiedItems,
        load,
        addAvailability,
        addOverride,
        updateItem,
        removeItem,
        saveAll,
        refreshBookingImpact: store.refreshBookingImpact,
        reset,
        setServiceId,
    };
}
